/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Help_Center_SearchInputs */

const en_page_title_help_center_search = /** @type {(inputs: Page_Title_Help_Center_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const nl_page_title_help_center_search = /** @type {(inputs: Page_Title_Help_Center_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoeken`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Page_Title_Help_Center_SearchInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_help_center_search = /** @type {((inputs?: Page_Title_Help_Center_SearchInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Help_Center_SearchInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_help_center_search(inputs)
	return en_page_title_help_center_search(inputs)
});